module.exports = __webpack_public_path__ + "static/img/200030.7b5e4462.png";